import React from "react";
import DeliveryReturnList from "./DeliveryReturnList";

const PreviousDeliveryReturn = ({ navigation }) => {
  return <DeliveryReturnList navigation={navigation} />;
};

export default PreviousDeliveryReturn;
